import React, { useMemo } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import '../../styles/Navbar.css';
import { useAuthUser } from 'react-auth-kit';
import useTranslations from '../../customHook/useTranslations';
import translations from '../../content/Navbar/Navbar.json';
import LangSwitcher from './LangSwitcher';

function toArr(arr) {
  return Array.isArray(arr) ? arr : [arr];
}
const KuobzIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 21"
    width="21"
    height="21"
    preserveAspectRatio="xMidYMid meet"
  >
    {/* Серый прямоугольник будет меняться по currentColor */}
    <rect x="4.5" y="0" width="12" height="21" rx="2" ry="2" fill="currentColor" />
    {/* Белый прямоугольник — не инвертируется */}
    <rect x="6.5" y="2" width="8" height="6" rx="2" ry="2" fill="#fff" />
  </svg>
);

function Navbar(props) {
  // получение словаря для статических данных в зависимости от выбранного языка
  const t = useTranslations(translations);
  const menu = [
    {
      link: '/devices',
      role: ['admin', 'engineerInfosignal', 'master', 'dispatcher'],
      src: '/image/menu_1.svg',
      title: t?.deviceManagement || 'Учет устройств',
      key: 23232,
    },
    {
      link: '/brigades',
      role: ['user', 'admin', 'customer', 'engineerInfosignal', 'master', 'dispatcher'],
      src: '/image/menu_2.svg',
      title: t?.brigadeManagement || 'Управление бригадами',
      key: 23234,
    },
    {
      link: '/uipps',
      role: ['admin', 'engineerInfosignal', 'master', 'dispatcher'],
      src: '/image/menu_3.svg',
      title: t?.uippsControl || 'Контроль УИППС',
      key: 23236,
    },
    {
      link: '/documentation',
      role: ['admin', 'customer', 'engineerInfosignal', 'master', 'dispatcher'],
      src: '/image/menu_4.svg',
      title: t?.reportingDocumentation || 'Отчетная документация',
      key: 23238,
    },
    {
      link: '/archive',
      role: ['admin', 'engineerInfosignal', 'master', 'dispatcher'],
      src: '/image/menu_5.svg',
      title: t?.archive || 'Архив',
      key: 23230,
    },

    {
      link: '/infocards',
      role: ['admin', 'engineerInfosignal', 'master', 'dispatcher'],
      src: '/image/menu_6.svg',
      title: t?.infoCards || 'Информационные карты',
      key: 23240,
    },
    {
      link: '/files',
      role: ['admin', 'engineerInfosignal', 'master', 'dispatcher'],
      src: '/image/file.svg',
      title: t?.files || 'Файлы',
      key: 23241,
    },

    {
      link: '/reports',
      role: ['reports'],
      src: '/image/menu_4.svg',
      title: t?.reports || 'Отчеты',
      key: 81,
    },
    {
      link: '/kuobz',
      role: ['engineer'],
      src: '/image/kuobz.svg',
      title: t?.kuobzEditing || 'Редактирование КУОБЗ',
      key: 6,
    },
    {
      link: '/administrate',
      role: ['admin', 'engineerInfosignal', 'master', 'dispatcher'],
      src: '/image/menu_7.svg',
      title: t?.dataAdministration || 'Администрирование данных',
      key: 191,
    },
  ];

  const user = useAuthUser()();
  const location = useLocation();

  const menuItems = useMemo(() => {
    const currentRoles = toArr(user?.role); // Преобразуем роли пользователя в массив

    return menu
      .filter((menuItem) => {
        // Проверка: если у пункта меню есть список ролей, которым он доступен
        if (menuItem.role) {
          const requiredRoles = toArr(menuItem.role);
          const hasAnyRequiredRole = requiredRoles.some((role) => currentRoles.includes(role));

          if (!hasAnyRequiredRole) return false; // нет нужных ролей — скрываем
        }

        // Проверка: если требуются все указанные роли
        if (menuItem.exactRole) {
          const requiredExactRoles = toArr(menuItem.exactRole);
          const hasAllExactRoles = requiredExactRoles.every((role) => currentRoles.includes(role));

          if (!hasAllExactRoles) return false;
        }

        return true;
      })
      .map((menuItem) => ({
        src: menuItem.src,
        title: menuItem.title,
        key: menuItem.key,
        to: {
          pathname: menuItem.link,
          search: location.search,
          hash: location.hash,
        },
      }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, location.hash, ...toArr(user?.role), t]);

  // Нет смысла показывать только одну кнопку навигации
  if (menuItems.length < 2) return <></>;

  return (
    <nav className="nav-container">
      <ul className="navbar__list">
        {menuItems.map((li) => (
          <NavLink to={li.to} key={li.key}>
            <li
              className={`navbar__item ${
                location.pathname === li.to.pathname || (li.to.pathname === '/documentation' && location.pathname === '/reports')
                  ? 'active'
                  : ''
              }`}
            >
              {li.src === '/image/kuobz.svg' ? (
                <KuobzIcon className="navbar__icon__kuobz" />
              ) : (
                <img className="navbar__icon" src={li.src} alt="" />
              )}
              <span className="navbar__text">{li.title}</span>
            </li>
          </NavLink>
        ))}
      </ul>
      {process.env.REACT_APP_LANG && <LangSwitcher />}
    </nav>
  );
}

export default Navbar;
